import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import log from "../images/LuxinHotel.png";

const PrintStyle = styled.div`
  font-family: Tahoma, sans-serif;
  @page {
    size: A5 portrait;
    margin: 10mm;
  }
  .print-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    border-bottom: 2px solid #ccc;
    padding-bottom: 8px;
  }
  .invoice-title {
    background: linear-gradient(90deg, #6c6c6c, #999);
    color: white;
    padding: 4px 16px;
    border-radius: 10px;
    font-size: 18px;
    font-weight: bold;
  }
  .logo {
    width: 60px;
    height: 90px;
    border-radius: 10%;
    margin-right: 15px; /* ✅ فاصله از راست */
  }
  .box {
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #fafafa;
    padding: 6px;
    margin-bottom: 8px;
  }
  .footer {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    margin-top: 10px;
    margin-left:20px;
  }
`;

const HotelInvoice_Pdf = forwardRef((props, ref) => {
  const [Rest_Sum, setRest_Sum] = useState(0);
  const today = new Date();

  useEffect(() => {
    getDataResturant();
  }, []);

  const getDataResturant = () => {
    let sum = 0;
    props.MyRest.map((row) => (sum = sum + row.Resturant_Pay));
    setRest_Sum(sum);
  };

  const printDocument = () => {
    const input = document.getElementById("divToPrint");
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a5",
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("invoice.pdf");
    });
  };

  useImperativeHandle(ref, () => ({
    pdf: printDocument,
  }));

  return (
    <div className="printing">
      <div id="divToPrint" className="mt4">
        <PrintStyle>
          {/* ===== Header ===== */}

          <div className="print-header">
            <div className="invoice-title">Luxin Hotel — Invoice</div>
            <img src={log} alt="Hotel Logo" className="logo" />
          </div>

          {/* ===== Info Section ===== */}
          <div className="box">
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>No:</TableCell>
                  <TableCell>{today.getFullYear()}{today.getMonth() + 1}{today.getDate()}{props.Room_Number}</TableCell>
                  <TableCell>Date:</TableCell>
                  <TableCell>
                    {today.getDate()}-{today.getMonth() + 1}-{today.getFullYear()}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Agency:</TableCell>
                  <TableCell>{props.Prese_Name}</TableCell>
                  <TableCell>Tel:</TableCell>
                  <TableCell>+995592472704</TableCell>
                </TableRow>

                {/* ✅ Added back Address + Tel */}
                <TableRow>
                  <TableCell>Address:</TableCell>
                  <TableCell colSpan={3}>
                    12-4 Konstantin Eristavi Dead End, Tbilisi
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>

          {/* ===== Passenger Info ===== */}
          <div className="box">
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>Passenger:</TableCell>
                  <TableCell>{props.Pass_FName + " " + props.Pass_LName}</TableCell>
                  <TableCell>Pass No:</TableCell>
                  <TableCell>{props.Pass_No}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Check In:</TableCell>
                  <TableCell>{props.Checkindate.slice(0, 10)}</TableCell>
                  <TableCell>Check Out:</TableCell>
                  <TableCell>{props.Checkoutdate.slice(0, 10)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Room No:</TableCell>
                  <TableCell>{props.Room_Number}</TableCell>
                  <TableCell>Guests:</TableCell>
                  <TableCell>{props.Adults_No}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>

          {/* ===== Price Summary (Dual Column) ===== */}
          <div className="box">
            <div style={{ fontSize: 13, fontWeight: "bold", marginBottom: 4 }}>Your Price Summary ($)</div>
            <div style={{ display: "flex", gap: "8px" }}>
              {/* Left column – additions */}
              <TableContainer sx={{ width: "50%", borderRadius: 2, boxShadow: 1 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#F5F5F5" }}>
                      <TableCell>Description</TableCell>
                      <TableCell align="right">$</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow><TableCell>Room</TableCell><TableCell align="right">{props.Reserv_Price}</TableCell></TableRow>
                    <TableRow><TableCell>Breakfast</TableCell><TableCell align="right">{props.Reserv_BreakfastAmount * props.Adults_No}</TableCell></TableRow>
                    <TableRow><TableCell>Extra</TableCell><TableCell align="right">{props.Reserv_ExtraAmount * props.Night_No}</TableCell></TableRow>
                    <TableRow><TableCell>Other</TableCell><TableCell align="right">{props.Reserv_Other}</TableCell></TableRow>
                    <TableRow><TableCell>Restaurant</TableCell><TableCell align="right">{props.RestTotal}</TableCell></TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Right column – deductions */}
              <TableContainer sx={{ width: "50%", borderRadius: 2, boxShadow: 1 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#F5F5F5" }}>
                      <TableCell>Deductions</TableCell>
                      <TableCell align="right">$</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow><TableCell>Discount</TableCell><TableCell align="right">{props.Reserv_Discount}</TableCell></TableRow>
                    <TableRow><TableCell>Prepayment</TableCell><TableCell align="right">{props.Reserv_prepayment}</TableCell></TableRow>
                    <TableRow style={{ backgroundColor: "#EDD682" }}>
                      <TableCell><b>Total Price</b></TableCell>
                      <TableCell align="right"><b>{props.Reserv_Advance}$</b></TableCell>
                    </TableRow>
                    <TableRow style={{ backgroundColor: "#EDD682" }}>
                      <TableCell><b>Total Price (Gel)</b></TableCell>
                      <TableCell align="right"><b>{props.Reserv_Advance * props.Rate} ₾</b></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>

          {/* ===== Footer ===== */}
          <div className="footer" >
            Thank you for your warm presence. We hope to see you again.<br />
            Manager, Luxin Hotel.
          </div>
        </PrintStyle>
      </div>
    </div>
  );
});

export default HotelInvoice_Pdf;
